export const drawerHeaderHeight = 60;

export const infiniteScrollTrigger = 800;

export const noResultRefScrollHeight = 620;

export const perPage = 20;
